import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5c6bbcbc&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c6bbcbc')) {
      api.createRecord('5c6bbcbc', component.options)
    } else {
      api.reload('5c6bbcbc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5c6bbcbc&", function () {
      api.rerender('5c6bbcbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/categoryAssociation/index.vue"
export default component.exports